
export enum BannerType {
    Block = 0,
    Chevron = 1,
    InverseChevron = 2,
    Convex = 3,
    Concave = 4
}
